import React from "react";

import { Box, OriginLogo, Text } from "@origin-digital/ods-core";
import { Link } from "@mui/material";
import { NavSectionProps, RequestCounts } from "../types";
import envConfig from "../../../envConfig/envHelper";
import NavItem from "../NavItem/NavItem";
import { useNavSection } from "./useNavSection";

const NavSection: React.FC<NavSectionProps> = ({
  shouldShowPrivateElements,
}) => {
  const { counts, navContent, user, isAuthenticated } = useNavSection();

  if (!isAuthenticated || !shouldShowPrivateElements) {
    return <OriginLogo variant="portrait" />;
  }
  return (
    <Box display="flex" justifyContent="space-between">
      <Box paddingY="medium">
        <Link href={envConfig.config.homeUrl} underline="none">
          <Box display="flex">
            <img
              src="https://www.originenergy.com.au/cdn/images/originenergy/image/upload/logos/origin_favicon-32x32.svg"
              height={24}
              width={24}
              style={{ marginRight: "8px" }}
            />
            <Text weight="medium" tone="neutralDark">
              Origin Connect
            </Text>
          </Box>{" "}
        </Link>
      </Box>
      {user?.role ? (
        <Box
          display="flex"
          justifyContent="space-between"
          paddingLeft="xxlarge"
          alignItems="center"
        >
          {navContent.map((navItem) => (
            <NavItem
              title={navItem.title}
              routes={navItem.routes}
              key={navItem.title}
              count={
                counts[
                  navItem.routes[0].replace("/", "") as keyof RequestCounts
                ]
              }
            />
          ))}
        </Box>
      ) : null}
    </Box>
  );
};

export default NavSection;
